export default {
  title: {
    en: 'Upgrade your subscription',
  },
  step1Title: {
    en: 'Step 1',
  },
  step2Title: {
    en: 'Step 2',
  },
  note: {
    en: `<b>NOTE:</b> Your <span class="brand">free item(s)</span> will be applied to your next billing cycle.`,
  },
  scentStepDesc: {
    en: 'Choose how many products per month you want',
  },
  scentStepDetailedDesc: {
    en: 'All subscriptions include fragrances, makeup and skincare.',
  },
  monthStepDesc: {
    en: 'Choose your subscription plan',
  },
  monthStepDetailedDesc: {
    en: 'Save on each shipment when you prepay, below. Pay:',
  },
}
